import { useAllowedEmpresas } from './useAllowedEmpresas'

/**
 * ¿Ve el usuario el módulo de fichas técnicas (BOM)?
 *
 * Las fichas nacieron en Tailored y el módulo estuvo cerrado a 'tdis'; desde
 * 2026-09-05 entra también 'avp'. Tener una de las dos entre las empresas
 * equivale exactamente a Empresa.TDIS / Empresa.AVP / Empresa.All por el mapeo
 * de core/permissions.py — mismo truco que useHasReportsAccess: no hace falta
 * ampliar /auth/me.
 *
 * Esto solo controla lo que se pinta. El cierre de verdad está en el backend
 * (get_bom_empresas), que devuelve 403 a quien no tenga acceso.
 */
export function useHasBomAccess(): boolean {
  const empresas = useAllowedEmpresas()
  return empresas.includes('tdis') || empresas.includes('avp')
}
